import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HelperService   } from '@shared/services';
import { CompanyDocument } from '@shared/factories';
import { CompanyDocumentModel, ParsedFileModel } from '@shared/models';

import { environment } from 'environments/environment';

export class CompanyDocumentResponseModel {
  company_agreement: CompanyDocumentModel;
}

@Injectable({
  providedIn: 'root'
})
export class CompanyDocumentsService {
  static CD_API = (eeId: number) =>{ return `${environment.apiUrl}api/portal/v3/external_employees/${eeId}/profile/company_documents/company_agreements` };
  constructor(
    private http:          HttpClient,
    private helperService: HelperService
  ) { }

  getCompanyDocumentById(eeId: number, companyId: number): Observable<CompanyDocument> {
    return this.http.get<CompanyDocumentResponseModel>(`${CompanyDocumentsService.CD_API(eeId)}/${companyId}`).pipe(
      map(res => new CompanyDocument(res?.company_agreement))
    );
  }

  getDocumentPDFAsBlob(eeId: number, companyId: number): Observable<ParsedFileModel> {
    return this.helperService.loadFileAsBlobByUrl(`${CompanyDocumentsService.CD_API(eeId)}_reports/${companyId}`, 'application/pdf');
  }

}
